export enum OrderCargoOrderChangeApprovalStatusRequestStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export type OrderCargoOrderChangeApprovalStatusRequestBody = {
  status: OrderCargoOrderChangeApprovalStatusRequestStatus;
};

type OrderCargoOrderChangeApprovalStatusRequest = {
  orderUuid: string;
  status: OrderCargoOrderChangeApprovalStatusRequestStatus;
};

export default OrderCargoOrderChangeApprovalStatusRequest;
